import React, { useState, useEffect, ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';
import { SendOutlined } from '@mui/icons-material';

interface Props {
  isVisible: boolean;
  user: {
    id: number;
    first_name: string;
    surname?: string;
    email: string;
  };
  onConfirm?: (text: string) => void;
  onClose?: () => void;
}

const RequireCompletionDialog: React.FC<Props> = (props: Props) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (props.isVisible) {
      setText(`Hej ${props.user.first_name} ${props.user.surname || ''},

Det registerutdrag du laddat upp på UngIntra var inte av läsbar kvalitet, och vi kan därför tyvärr inte godkänna det.

Vänligen ladda upp båda sidorna igen i bättre kvalitet.

Vänliga hälsningar,

Ung Omsorg`);
    }
  }, [props.isVisible]);

  const handleConfirm = () => {
    props.onConfirm?.(text);
    props.onClose?.();
    setText('');
  };

  return (
    <Dialog open={props.isVisible} onClose={props.onClose} maxWidth="md" fullWidth>
      <DialogTitle className="text-xl text-neutral-600 !font-bold">Begär komplettering</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div>
            <p>Instruktioner till den anställde för komplettering av filuppladdning.</p>
            <p className="mt-4">
              Mail skickas till: {props.user.first_name} {props.user?.surname} ({props.user.email})
            </p>
            <p className="mt-4">
              <TextField
                inputProps={{
                  className: '!text-neutral-600',
                }}
                multiline
                rows={4}
                fullWidth
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </p>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="!px-[20px] !py-[24px] !justify-between">
        <Button className="w-52 h-12" variant="outlined" color="error" onClick={props.onClose}>
          Avbryt
        </Button>

        <Button
          className="w-52 h-13"
          variant="contained"
          color="primary"
          endIcon={<SendOutlined />}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: '#43967680',
              color: 'white',
              opacity: 1,
            },
          }}
          onClick={handleConfirm}
        >
          Begär
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequireCompletionDialog;
